<template>
  <!--  PC -->
  <div>
    <div v-if="hasDashboardCharts" class="dashboard-layout-auto">
      <component v-for="chart in hasDashboardCharts" :is="chart" :dataType="dataType" />
    </div>
    <div v-if="successLoadGraph && !hasDashboardCharts" class="dashboard-layout-auto">
      <donut-chart01 :dataType="dataType" />
      <donut-chart02 :dataType="dataType" />
      <donut-chart03 :dataType="dataType" />
      <donut-chart04 :dataType="dataType" v-if="parseInt(projectId) !== 2" />
      <donut-chart05 :dataType="dataType" />
      <health-safety-budget-execution-rate-chart :data-type="dataType" />
      <donut-chart06 :dataType="dataType" />
      <donut-chart07 :dataType="dataType" />
      <donut-chart08 :dataType="dataType" />
      <donut-chart09 :dataType="dataType" />
      <donut-chart10 :dataType="dataType" />
      <donut-chart11 :dataType="dataType" />
      <donut-chart12 :dataType="dataType" />
      <donut-chart13 :dataType="dataType" />
      <donut-chart14 :dataType="dataType" />

      <!-- 시설물 점검 현황 -->
      <donut-chart16 :dataType="dataType" />
      <!-- 시설물 진단 현황 -->
      <donut-chart17 :dataType="dataType" />
      <!-- 시설물 보수 현황 -->
      <donut-chart18 :dataType="dataType" />
      <!-- 시설물 보강 현황 -->
      <donut-chart19 :dataType="dataType" />
      <!-- 시설물 교체 현황 -->
      <donut-chart20 :dataType="dataType" />
    </div>
    <div v-if="type !== 'home'" class="dashboard-layout-2">
      <home-notification-card title="은평구청 안전·보건 경영 시스템 " :disabled="myInfo.is_superuser >= 1 ? false : true" />
      <community-healthinfo-card />
      <community-business-news-card />
      <community-work-news-card />
    </div>
  </div>
</template>

<script>
import DonutChartCard from "@/components/DonutChartCard";
import HomeNotificationCard from "@/components/HomeNotificationCard";
import CommunityHealthinfoCard from "@/components/CommunityHealthinfoCard";
import CommunityWorkNewsCard from "@/components/CommunityWorkNewsCard";
import CommunityBusinessNewsCard from "@/components/CommunityBusinessNewsCard";
import DonutChart01 from "@/views/graph/DonutChart01";
import DonutChart02 from "@/views/graph/DonutChart02";
import DonutChart03 from "@/views/graph/DonutChart03";
import DonutChart04 from "@/views/graph/DonutChart04";
import DonutChart05 from "@/views/graph/DonutChart05";
import DonutChart06 from "@/views/graph/DonutChart06";
import DonutChart07 from "@/views/graph/DonutChart07";
import DonutChart08 from "@/views/graph/DonutChart08";
import DonutChart09 from "@/views/graph/DonutChart09";
import DonutChart10 from "@/views/graph/DonutChart10";
import DonutChart11 from "@/views/graph/DonutChart11";
import DonutChart12 from "@/views/graph/DonutChart12";
import DonutChart13 from "@/views/graph/DonutChart13";
import DonutChart14 from "@/views/graph/DonutChart14";
import HealthSafetyBudgetExecutionRateChart from "@/views/graph/HeathSafetyBudgetExecutionRateChart";
import DonutChart16 from "@/views/graph/DonutChart16.vue";
import DonutChart17 from "@/views/graph/DonutChart17.vue";
import DonutChart18 from "@/views/graph/DonutChart18.vue";
import DonutChart19 from "@/views/graph/DonutChart19.vue";
import DonutChart20 from "@/views/graph/DonutChart20.vue";
import DonutChart22 from "@/views/graph/DonutChart22";
import DonutChart23 from "@/views/graph/DonutChart23";
import DonutChart24 from "@/views/graph/DonutChart24";
import DonutChart25 from "@/views/graph/DonutChart25";
import DonutChart21 from "@/views/graph/DonutChart21";
import DonutChart26 from "@/views/graph/DonutChart26";
import DonutChart27 from "@/views/graph/DonutChart27";
import DonutChart28 from "@/views/graph/DonutChart28";
import DonutChart29 from "@/views/graph/DonutChart29";
import DonutChart30 from "@/views/graph/DonutChart30";
import DonutChart31 from "@/views/graph/DonutChart31";
import DonutChart32 from "@/views/graph/DonutChart32";
import DonutChart33 from "@/views/graph/DonutChart33";
import DonutChart34 from "@/views/graph/DonutChart34";
import DonutChart35 from "@/views/graph/DonutChart35";
import DonutChart36 from "@/views/graph/DonutChart36";
import DonutChart42 from "@/views/graph/DonutChart42";
import DonutChart43 from "@/views/graph/DonutChart43";
import DonutChart44 from "@/views/graph/DonutChart44";
import DonutChart45 from "@/views/graph/DonutChart45";
import DonutChart46 from "@/views/graph/DonutChart46";
import DonutChart47 from "@/views/graph/DonutChart47";
import DonutChart48 from "@/views/graph/DonutChart48";
import DonutChart49 from "@/views/graph/DonutChart49";
import DonutChart50 from "@/views/graph/DonutChart50";
import DonutChart51 from "@/views/graph/DonutChart51";
import DonutChart52 from "@/views/graph/DonutChart52";
import DonutChart53 from "@/views/graph/DonutChart53";
import DonutChart54 from "@/views/graph/DonutChart54";
import DonutChart55 from "@/views/graph/DonutChart55";
import DonutChart56 from "@/views/graph/DonutChart56";
import DonutChart57 from "@/views/graph/DonutChart57";
import DonutChart58 from "@/views/graph/DonutChart58";
import DonutChart59 from "@/views/graph/DonutChart59";
import DonutChart60 from "@/views/graph/DonutChart60";
import DonutChart61 from "@/views/graph/DonutChart61";
import DonutChart62 from "@/views/graph/DonutChart62";
import DonutChart63 from "@/views/graph/DonutChart63";
import DonutChart64 from "@/views/graph/DonutChart64";
import DonutChart65 from "@/views/graph/DonutChart65";
import DonutChart66 from "@/views/graph/DonutChart66";
import DonutChart67 from "@/views/graph/DonutChart67";
import DonutChart68 from "@/views/graph/DonutChart68";
import DonutChart69 from "@/views/graph/DonutChart69";
import DonutChart70 from "@/views/graph/DonutChart70";
import DonutChart71 from "@/views/graph/DonutChart71";
import DonutChart72 from "@/views/graph/DonutChart72";

export default {
  components: {
    DonutChart312: () => import("@/views/graph/DonutChart312"),
    DonutChart90: () => import("@/views/graph/DonutChart90"),
    DonutChart86: () => import("@/views/graph/DonutChart86"),
    DonutChart85: () => import("@/views/graph/DonutChart85"),
    DonutChart84: () => import("@/views/graph/DonutChart84"),
    DonutChart83: () => import("@/views/graph/DonutChart83"),
    DonutChart82: () => import("@/views/graph/DonutChart82"),
    DonutChart81: () => import("@/views/graph/DonutChart81"),
    DonutChart80: () => import("@/views/graph/DonutChart80"),
    DonutChart79: () => import("@/views/graph/DonutChart79"),
    DonutChart78: () => import("@/views/graph/DonutChart78"),
    DonutChart77: () => import("@/views/graph/DonutChart77"),
    DonutChart76: () => import("@/views/graph/DonutChart76"),
    DonutChart75: () => import("@/views/graph/DonutChart75"),
    DonutChart74: () => import("@/views/graph/DonutChart74"),
    DonutChart73: () => import("@/views/graph/DonutChart73"),
    DonutChart72,
    DonutChart71,
    DonutChart70,
    DonutChart69,
    DonutChart68,
    DonutChart67,
    DonutChart66,
    DonutChart65,
    DonutChart64,
    DonutChart63,
    DonutChart62,
    DonutChart61,
    DonutChart60,
    DonutChart59,
    DonutChart58,
    DonutChart57,
    DonutChart56,
    DonutChart55,
    DonutChart54,
    DonutChart53,
    DonutChart52,
    DonutChart51,
    DonutChart50,
    DonutChart49,
    DonutChart48,
    DonutChart47,
    DonutChart46,
    DonutChart45,
    DonutChart44,
    DonutChart43,
    DonutChart42,
    DonutChart36,
    DonutChart35,
    DonutChart34,
    DonutChart33,
    DonutChart32,
    DonutChart31,
    DonutChart30,
    DonutChart29,
    DonutChart28,
    DonutChart27,
    DonutChart26,
    DonutChart25,
    DonutChart24,
    DonutChart23,
    DonutChart22,
    DonutChart21,
    DonutChart20,
    DonutChart19,
    DonutChart18,
    DonutChart17,
    DonutChart16,
    HealthSafetyBudgetExecutionRateChart,
    DonutChart14,
    DonutChart13,
    DonutChart12,
    DonutChart11,
    DonutChart10,
    DonutChart09,
    DonutChart08,
    DonutChart07,
    DonutChart06,
    DonutChart05,
    DonutChart04,
    DonutChart03,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard,
  },
  props: {
    type: String,
  },
  data() {
    return {
      rootPath: "",
      successLoadGraph: false,
      alertList: [],
    };
  },
  async created() {
    const paths = this.$route.path.split("/");
    this.rootPath = `/${paths[1]}/${paths[2]}`;
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then((value) => {
      this.successLoadGraph = true;
    });
  },
  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    mobileCardMenus() {
      if (Number(`${this.projectId}`) === 2) {
        return [
          {
            url: "tab/664/write",
            name: "유해·위험요인 조사표",
            icon: "BookOpenIcon",
            boardId: "664",
          },
          {
            url: "tab/160/write",
            name: "유해·위험요인 개선사항",
            icon: "ToolIcon",
            boardId: "160",
          },
          {
            url: "tab/672/write",
            name: "정기 위험성평가",
            icon: "AlertTriangleIcon",
            boardId: "672",
          },
          {
            url: "tab/673/write",
            name: "수시 위험성평가",
            icon: "AlertTriangleIcon",
            boardId: "673",
          },
          {
            url: "tab/508/write",
            name: "TBM(작업 전 안전 미팅일지)",
            icon: "UsersIcon",
            boardId: "508",
          },
          {
            url: "tab/291/write",
            name: "안전 순회점검표",
            icon: "CheckSquareIcon",
            boardId: "291",
          },
          {
            url: "tab/290/write",
            name: "보건 순회점검표",
            icon: "CheckSquareIcon",
            boardId: "290",
          },
          {
            url: "tab/293/write",
            name: "근골격계부담작업체크리스트",
            icon: "UserCheckIcon",
            boardId: "293",
          },
          {
            url: "tab/372/write",
            name: "아차사고 등록",
            icon: "AlertTriangleIcon",
            boardId: "372",
          },
        ];
      }
      return [];
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    myLv() {
      return parseInt(`${this.$store.state.auth.userInfo.position}`);
    },
    companyInfo() {
      return this.$store.state.auth.companyInfo;
    },
    hasDashboardCharts() {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts;
      if (hasDashboardCharts) {
        const list = [];
        for (const chart of hasDashboardCharts) {
          if (chart.visible && Number(`${chart.project_id}`) === Number(`${this.projectId}`)) {
            const code = chart.dashboard_chart.code;
            list.push(code);
          }
        }
        return list;
      }

      return undefined;
    },
    rootCompanyList() {
      const list = [];
      for (const company of this.$store.state.company.companyList) {
        if (typeof company !== "undefined" && typeof company.com_type !== "undefined" && company.com_type === "head") {
          list.push(company);
        }
      }
      return list;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      for (const company of this.rootCompanyList) {
        if (myInfo.company_id === company.id) {
          isAdmin = true;
          break;
        }
      }

      return isAdmin;
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = [];
      let hasRootHead = false;
      const headList = [];

      if (companyTree && companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && typeof com.descendant.com_type !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    dataType() {
      if (Number(`${this.comGroupList.maxDepth}`) === 0) {
        return "detail";
      }
      return "company";
    },
  },
  async mounted() {
    await this.loadCompanyList();

    if (this.verticalNavMenuWidth !== "default") {
      await this.loadAlertList();
    }
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },

    async loadAlertList() {
      const options = {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,

        page_read: 1,
        per_page_read: 5,
        days_before_read: 30,
      };
      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_LIST", options);

      const readList = this.$store.state.approval.alertReadList;
      const unreadList = this.$store.state.approval.alertUnReadList;

      this.alertList = unreadList;
    },

    onClickAlert(alert) {
      const data = JSON.parse(alert.data);
      if (data && data.project_id && data.board_id && data.post_id) {
        const projectId = data.project_id;
        const boardId = data.board_id;
        const postId = data.post_id;
        this.$router.push({ path: `/project/${projectId}/tab/${boardId}/write/${postId}` });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dashboard-layout-2 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 16px;
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
}
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 1310px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (min-width: 1660px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.m-dashboard-menu {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  .item {
    padding: 0.5rem;
    min-height: 100px;
    margin-bottom: 0rem;
    box-shadow: 0px 2px 8px 0px #00000021;
    border-radius: 8px;
  }
}
.m-alarm-list {
  width: auto;
  .board {
    border: 1px solid #cdcdcd;
  }
}
</style>
